<template>
  <FlashMessage v-if="flashMessageActive" state="success">
    {{ $t("workspaceDetail.move.success") }}
    <RouterLink
      v-if="targetWorkspaceId"
      class="link"
      :to="{ name: 'Workspace', params: { workspaceId: targetWorkspaceId } }"
      >{{ $t("workspaceDetail.move.goToWorkspace") }}</RouterLink
    >
  </FlashMessage>
  <folder-picker
    @close="close"
    @submit="submit"
    :active="modalActive"
    :sourceItemName="workspace.name"
    action="MOVE"
    :submitting="submitting"
    :error-message="failed ? $t('error') : ''"
  />
</template>
<script lang="ts" setup>
import { onBeforeUnmount, ref } from "vue";
import { FlashMessage, FolderPicker } from "@/components";
import { Workspace, useMoveFolderMutation } from "@/graphql/operations";
import { reloadWorkspaces } from "@/init";
import { RouterLink } from "vue-router";
const props = defineProps<{ workspace: Workspace }>();
const emit = defineEmits(["close", "success"]);
const flashMessageActive = ref(false);
const modalActive = ref(true);
const submitting = ref(false);
const failed = ref(false);
const targetWorkspaceId = ref<string>();
let timer: number | undefined;
let unmounted = false;
onBeforeUnmount(() => {
  unmounted = true;
  window.clearTimeout(timer);
});
const close = () => {
  if (!submitting.value) emit("close");
};
const { executeMutation } = useMoveFolderMutation();
const submit = async (parentId: string | undefined) => {
  if (!parentId || submitting.value) return;
  submitting.value = true;
  failed.value = false;
  try {
    const result = await executeMutation({ id: props.workspace.id, parentId });
    if (unmounted) return;
    if (result.error) {
      failed.value = true;
      return;
    }
    targetWorkspaceId.value = parentId;
    try {
      await reloadWorkspaces();
    } catch (error) {
      console.error("Reloading workspaces after committed move failed", error);
    }
    if (unmounted) return;
    emit("success");
    modalActive.value = false;
    flashMessageActive.value = true;
    timer = window.setTimeout(() => emit("close"), 4000);
  } catch {
    if (!unmounted) failed.value = true;
  } finally {
    submitting.value = false;
  }
};
</script>
